export const CENTERED_TILES = 'centeredTiles';
export const WHEEL_BUTTONS = 'wheelButtons';
export const BOTTOM_TILES = 'bottomTiles';
export const DESIGN_OPTIONS = [CENTERED_TILES, WHEEL_BUTTONS, BOTTOM_TILES];
